import React ,{useState}from 'react'
import CustomSelectFilter from "./CustomSelectFilter";
const SelectedFilter = ({element,index,removeFilter}) => {
    // const [levelMenu, setLevelMenu] = useState(() => false);
  return (
    <div className="filter-body" >
    <div
      className="filtered-data"
     
      // onClick={() => setLevelMenu(!levelMenu)}
    >
      <i
      onClick={() => removeFilter(index)}
      className="fa fa-times-circle"
    ></i>
      <span className="filtered-name">{element.key} : {element.values[0].toString()}</span>
      {/* <span className="badge rounded-pill badge-primary">
        {element.values.length}
      </span> */}
      {/* <i className="fa fa-angle-down"></i> */}
    </div>
    {/* <ul
      className="header-level-menu menu-to-be-close"
      style={levelMenu ? { display: "" } : { display: "none" }}
    >
      <li className="border-0" key={"filter-data"}>
      <CustomSelectFilter columnValue={element.values}/>
      </li>
    </ul> */}
  </div>
  )
}

export default SelectedFilter